export default __webpack_public_path__ + "static/media/icon-wal-color.ec180664.svg";